import React from 'react';
import { Hero } from '../components/sections/Hero';
import { TrustBar } from '../components/sections/TrustBar';
import { WhyDestaMeet } from '../components/sections/WhyDestaMeet';
import { RoiStats } from '../components/sections/RoiStats';
import { SignatureExperiences } from '../components/sections/SignatureExperiences';
import { ProcessTimeline } from '../components/sections/ProcessTimeline';
import { SocialProof } from '../components/sections/SocialProof';
import { CtaSection } from '../components/sections/CtaSection';
export function Home() {
  return <>
      <Hero data-id="element-1356" />
      <TrustBar data-id="element-1357" />
      <WhyDestaMeet data-id="element-1358" />
      <RoiStats data-id="element-1359" />
      <SignatureExperiences data-id="element-1360" />
      <ProcessTimeline data-id="element-1361" />
      <SocialProof data-id="element-1362" />
      <CtaSection data-id="element-1363" />
    </>;
}